<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
<style>
body {
  background-color: #191919;
  width: 100%;
}
@media screen and (max-width: 1280px) {
  body {
    width: 1280px;
  }
}
</style>





// WEBPACK FOOTER //
// src/App.vue